import { useEffect, useState } from 'react';
import http from '../../config/BaseUrl';
import { useGalleryAccess } from './GalleryAccess';

export default function useGallerySummary(refreshKey = '', eventId = '') {
  const { enabled } = useGalleryAccess();
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    if (!enabled) { setSummary(null); return undefined; }
    let active = true;
    let pending = false;
    const load = async () => {
      if (pending || document.hidden) return;
      pending = true;
      try {
        const { data } = await http.get('social-gallery-v2/lead-summary', { params: eventId ? { event_id: eventId } : {} });
        const result = data?.data;
        if (active) setSummary(result?.counts && Number.isFinite(result.total) ? result : null);
      } catch (_) {
        if (active) setSummary(null);
      } finally { pending = false; }
    };
    load();
    const interval = window.setInterval(load, 60000);
    window.addEventListener('focus', load);
    return () => { active = false; window.clearInterval(interval); window.removeEventListener('focus', load); };
  }, [refreshKey, eventId, enabled]);
  return enabled ? summary : null;
}
